import Vue from 'vue/dist/vue.esm'
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: 'zh-TW',
    messages: {
        'zh-TW': require('@config/locales/zh-TW.json'),
        'zh-CN': require('@config/locales/zh-CN.json'),
        'en-US': require('@config/locales/en-US.json'),
        'ko-KR': require('@config/locales/ko-KR.json'),
        'ja-JP': require('@config/locales/ja-JP.json'),
        'es-ES': require('@config/locales/es-ES.json'),
        'vi-VN': require('@config/locales/vi-VN.json'),
        'de-DE': require('@config/locales/de-DE.json'),
        'km-KH': require('@config/locales/km-KH.json')
    }
});

export default i18n;
